module.exports = __webpack_public_path__ + "static/media/Teleflex_Logo_BK.5e5b4e3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Teleflex_Logo_BK.png
// module id = 1367
// module chunks = 0